import { useMediaQuery } from '@mui/material';
import { useRef, useCallback, useLayoutEffect } from 'react';
const useMobileResize = () => {
    const isMobileSize = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const textRef = useRef(null);
    const pictureRef = useRef(null);
    const handleResize = useCallback(() => {
        if (textRef.current && pictureRef.current) {
            const textHeight = textRef.current.offsetHeight;
            const pictureHeight = pictureRef.current.offsetHeight;
            if (textHeight > 750) {
                const topOffset = (textHeight - pictureHeight) / 2;
                pictureRef.current.style.top = `calc(${topOffset}px)`;
            }
            else {
                pictureRef.current.style.top = '-50px';
                pictureRef.current.style.height = `calc(${textHeight}px + 45px)`;
            }
        }
    }, []);
    useLayoutEffect(() => {
        if (!isMobileSize)
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize, isMobileSize]);
    return { textRef, pictureRef, isMobileSize };
};
export default useMobileResize;
